var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDestinationPending({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C18.6274 0 24 5.37258 24 12C24 18.2916 19.1579 23.4512 12.9971 23.958C12.9976 23.972 13 23.9859 13 24V31C13 31.5523 12.5523 32 12 32C11.4477 32 11 31.5523 11 31V24C11 23.9859 11.0014 23.9719 11.002 23.958C4.84154 23.4507 0 18.2913 0 12C0 5.37258 5.37258 0 12 0Z",
    fill: "white",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM8.59961 8.37305V16.124H11.7471C14.0833 16.124 15.4637 14.6789 15.4639 12.2031V12.1924C15.4639 9.72705 14.0835 8.37305 11.7471 8.37305H8.59961ZM11.4893 9.96289C12.73 9.96289 13.4609 10.7471 13.4609 12.1973V12.208C13.4609 13.7549 12.7729 14.5342 11.4893 14.5342H10.5713V9.96289H11.4893Z",
    fill: "#9664F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestinationPending);
export default __webpack_public_path__ + "static/media/destination-pending.ec2e3e627342970b7aaf438ae77d793e.svg";
export { ForwardRef as ReactComponent };